// extracted by mini-css-extract-plugin
module.exports = {"flex":"Gift_flex__1ItFU","img":"Gift_img__puCuD"};